import teamsService from "../../services/teams"

export const SET_TEAMS = "SET_TEAMS"
export const UPDATE_TEAM = "UPDATE_TEAM"
export const ADD_TEAM = "ADD_TEAM"
export const DELETE_TEAM = "DELETE_TEAM"

const update = (team) => {
  return {
    type: UPDATE_TEAM,
    team
  }
}

const add = (team) => {
  return {
    type: ADD_TEAM,
    team
  }
}

const remove = (team) => {
  return {
    type: DELETE_TEAM,
    team
  }
}

export const updateTeam = (tenant, _team, team) => {
  return (dispatch) => {
    return teamsService.update(tenant.uuid, team, team.Etag).then((updatedTeam) => {
      return dispatch(update(updatedTeam))
    })
  }
}

export const createTeam = (tenant, name) => {
  return (dispatch) => {
    const team = {public_name: name}
    return teamsService.create({tenantId: tenant.uuid, data: team}).then((createdTeam) => {
      dispatch(add(createdTeam))
      return createdTeam
    })
  }
}

export const deleteTeam = (tenant, team) => {
  return (dispatch) => {
    return teamsService.delete(tenant.uuid, team.uuid, team.Etag).then(() => {
      return dispatch(remove(team))
    })
  }
}

export default {
  create: createTeam,
  deleteTeam,
  updateTeam
}
